module.exports = __webpack_public_path__ + "img/userB.9051e2bf.png";